// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1kJ1aZQVWkBHwgoJ","wrapper--collapsed":"ZIsciA7S-69X6R_3"};